import RoleDetails from "./users-role";

export default RoleDetails;
